<header class="portfolio-header">
  <section class="portfolio-header__container container">
    <!-- header logo -->
    <div class="company-info">
      <img
        class="info-img"
        [ngSrc]="headerData()?.logo?.thumbnail | imageSource"
        width="56"
        height="56"
        [alt]="headerData()?.title | translateData" />

      <div class="info-content">
        <h1 class="info-content__title">
          <pwj-text-summarizer
            [text]="headerData()?.title | translateData"
            [limitLength]="29"></pwj-text-summarizer>
        </h1>
      </div>
    </div>
    <!-- header menu -->
    <ul class="header-menu">
      @for (menuItem of headerMenu; track menuItem.id) {
        <li
          class="header-menu__item"
          [ngClass]="{
            'header-menu__item--active': currentFragment === menuItem.route,
          }">
          <a class="menu-item" routerLink="." [fragment]="menuItem.route">
            <i
              class="iconsax menu-item__icon"
              [attr.icon-name]="menuItem.icon"></i>
            <span class="menu-item__text">{{
              menuItem.title | translate
            }}</span>
          </a>
        </li>
      }
    </ul>
    <!-- header buttons -->
    <div class="header-btns">
      <!-- languages button -->
      <pwj-buttons-menu
        class="header-btns__languages"
        menuIcon="globe-refresh"
        [menuText]="selectedLang || 'global.language'"
        [menuItems]="languagesMenuItems"
        (onValueChange)="setLang($event)">
      </pwj-buttons-menu>

      <!-- barcode button -->

      <pwj-button
        class="header-btns__qr-button"
        variant="secondary"
        [textCenter]="true"
        icon="scan-2"
        iconClasses="!text-3xl !-mt-4"
        (click)="openQrCodeDialog()"
        buttonClasses="!w-80 !h-40 !pt-14"
        >{{ 'products.qr' | translate }}
      </pwj-button>
    </div>
  </section>
</header>
